function formatCurrency(
  a: { value: number; currency_iso: string; minimumFractionDigits?: number },
  locale: string,
): string {
  if (a.value === undefined || a.value === null) {
    return '';
  }

  if (!a.currency_iso) return a.value.toString();

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: a.currency_iso,
    minimumFractionDigits: a.minimumFractionDigits === undefined ? 2 : a.minimumFractionDigits,
  });

  return formatter.format(a.value);
}

function formatNumber(a: { value: number }, lng: string): string {
  if (!a.value) {
    return '';
  }

  const formatter = new Intl.NumberFormat(lng);

  return formatter.format(a.value);
}

function totalFromStrings(value: Maybe<string>, quantity: Maybe<string>) {
  if (!value || !quantity) return 0;

  const parsedQuantity = parseInt(quantity, 10);
  const parsedValue = parseFloat(value);

  return parsedValue * parsedQuantity;
}

function safelyConvertStringToNumber(value?: string): number | undefined {
  try {
    const parsed = Number(value);
    if (!isNaN(parsed)) {
      return parsed;
    }
    return undefined;
  } catch {
    return undefined;
  }
}

export { formatCurrency, formatNumber, totalFromStrings, safelyConvertStringToNumber };
